/**
 * Channel number
 *
 * @group CTA-608
 * @beta
 */
export type Channels = 0 | 1 | 2; // Will be 1 or 2 when parsing captions
